import React, {MouseEvent, useCallback} from 'react';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ButtonV3} from 'components/ButtonV3';
import Icon from 'components/Icon';

type TReserveButtonProps = Pick<IProductSnippet['cart'], 'onReserve'> & Pick<IProductSnippet, 'url'>;

export const ReserveButton = (props: TReserveButtonProps) => {
    const {onReserve, url} = props;

    // href нужен только как семантическая ссылка на товар (SEO/фолбэк) — клик открывает
    // флоу бронирования, а не переходит на PDP
    const handleClick = useCallback(
        (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            e.preventDefault();
            onReserve?.();
        },
        [onReserve],
    );

    return (
        <>
            <ButtonV3 href={url} isIconButton={true} size={'medium'} theme={'primary'} onClick={handleClick}>
                <Icon icon={'plus'} />
            </ButtonV3>
        </>
    );
};
